import React, { useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import CardComponent from "../../components/CardComponent";
import { ReactComponent as RupeeIcon } from "../../assets/rupee-icon.svg";
import { useTranslation } from "react-i18next";
import { WidgetItem } from "../../interfaces/TournamentsConfig";

interface PrizeDistributionCardProps {
  tournament: WidgetItem;
}

const PrizeDistributionCard: React.FC<PrizeDistributionCardProps> = ({
  tournament,
}) => {
  const { t } = useTranslation();
  const { poolDistributionInfo } = tournament || {};
  const {distribution} = poolDistributionInfo || {};
  const defaultViewLimit = 3;
  const [expand, setExpand] = useState(false);

  const expandPrizeList = () => {
    setExpand(!expand);
  };

  const getMedalEmoji = (index: number) => ["🥇", "🥈", "🥉"][index] || null;

  return (
    <CardComponent
      className={clsx(styles.prizeDistributionCard, styles.cardWithHeading)}
      borderType="Md"
    >
      <>
        <div
          className={clsx(
            styles.cardHeading,
            "fontSizeSm fontWeightBold fontColorBlack"
          )}
        >
          <RupeeIcon />
          {t("prizeDistribution")}
        </div>
        {distribution?.map(({ label, amt }, index) => {
          if (index >= defaultViewLimit && !expand) {
            return null;
          }
          return (
            <div
              className={clsx(styles.detailingRow)}
              key={`${label}-${amt}-${index}`}
            >
              <div
                className={clsx(
                  styles.valueTitle,
                  "fontWeightMedium fontColorBlack fontSizeSm14"
                )}
              >
                {label}
              </div>
              <div
                className={clsx(
                  styles.value,
                  "fontWeightMedium fontColorBlack fontSizeSm14"
                )}
              >
                {getMedalEmoji(index)} {amt}
              </div>
            </div>
          );
        })}
        {(distribution?.length ?? 0) > defaultViewLimit && (
          <div
            className={clsx(
              styles.viewAllBtn,
              "textAlignRight fontColorSecondary fontWeightBold fontSizeXs textUppercase"
            )}
            onClick={expandPrizeList}
          >
            {!expand ? t("viewAll") : t("less")}
          </div>
        )}
      </>
    </CardComponent>
  );
};

export default PrizeDistributionCard;
